// extracted by mini-css-extract-plugin
export default {"col":"styles_col__J7BSG","formItem":"styles_formItem__UiI3R","label":"styles_label__W7bZb"};